import React from "react";

import preapprovalLogo from "./logo/PreAproval-By-Snaphomz_01.png";
import preapprovalGif from "./logo/preapproval.gif";
import snapInterestLogo from "./logo/SnapInterest-By-Snaphomz_01.png";
import snapAuditLogo from "./logo/SnapAudit-By-Snaphomz_01.png";
import rentVsBuyLogo from "./logo/Rent-Vs.-Buy-By-Snaphomz_03.png";
import snapDisclosureLogo from "./logo/SnapDisclosure-By-Snaphomz_01.png";

const LEFT_FEATURED = {
  key: "preapproval",
  logoSrc: preapprovalLogo,
  gifSrc: preapprovalGif,
  logoAlt: "SnapPreApproval logo",
  descPoints: [
    "Instant pre-approval in seconds with a simple guided flow.",
    "Verified pre-approval delivered in under 24 hours to strengthen offers.",
  ],
  href: "https://preapproval.snaphomz.com/?utm_source=satellite_site&utm_medium=bottom_panel&utm_campaign=snapgrad",
};

const TOOLS = [
  {
    key: "snapinterest",
    logoSrc: snapInterestLogo,
    logoAlt: "SnapInterest logo",
    // UPDATED: Reduced to h-9 as requested
    logoClass: "h-8 md:h-9 w-auto", 
    desc: "Compare interest rate scenarios and understand payment impact before locking.",
    href: "https://snapinterest.snaphomz.com/?utm_source=satellite_site&utm_medium=bottom_panel&utm_campaign=snapgrad",
  },
  {
    key: "snapaudit",
    logoSrc: snapAuditLogo,
    logoAlt: "SnapAudit logo",
    // Kept larger (h-11) to match visual weight
    logoClass: "h-10 md:h-11 w-auto",
    desc: "Summarizes disclosures into clear, buyer-friendly insights and flags key risks fast.",
    href: "https://snapaudit.snaphomz.com/?utm_source=satellite_site&utm_medium=bottom_panel&utm_campaign=snapgrad",
  },
  {
    key: "rentvsbuy",
    logoSrc: rentVsBuyLogo,
    logoAlt: "Rent vs Buy logo",
    // Kept smaller because the logo is blocky
    logoClass: "h-7 md:h-8 w-auto",
    desc: "See rent vs. buy scenarios with clear payment and affordability guidance.",
    href: "https://rentvsbuy.snaphomz.com/?utm_source=satellite_site&utm_medium=bottom_panel&utm_campaign=snapgrad",
  },
  {
    key: "snapdisclosure",
    logoSrc: snapDisclosureLogo,
    logoAlt: "SnapDisclosure logo",
    // Kept larger because the logo is wide/thin
    logoClass: "h-10 md:h-[44px] w-auto",
    desc: "Highlights risks in disclosure documents and flags items needing review.",
    href: "https://snapdisclosures.snaphomz.com/?utm_source=satellite_site&utm_medium=bottom_panel&utm_campaign=snapgrad",
  },
];

const LEFT_CTA_BUTTON =
  "px-6 py-2 rounded-full " +
  "bg-gradient-to-b from-[#ff9341] via-[#ff7a24] to-[#f26a16] " +
  "shadow-[0_12px_26px_rgba(242,106,22,0.35)] " +
  "text-white text-base font-semibold " +
  "hover:shadow-[0_18px_36px_rgba(242,106,22,0.45)] " +
  "transition-all";

const RIGHT_TILE_BUTTON =
  "w-full inline-flex items-center justify-center px-6 py-2 rounded-full " +
  "bg-gradient-to-b from-[#111] to-[#000] text-white text-base font-semibold " +
  "shadow-[0_10px_30px_rgba(0,0,0,0.35)] whitespace-nowrap " +
  "hover:translate-y-[-1px] transition-all";

// h-14 container ensures good spacing
const TOOL_LOGO_WRAP_CLASS = "mb-3 flex items-center justify-start h-14";

export default function MoreToolsToTry() {
  return (
    <section className="w-full bg-gradient-to-b from-[#f8f5f1] via-[#f3efea] to-[#ebe6e0] rounded-[36px] shadow-[0_28px_90px_rgba(0,0,0,0.12)] border border-[#e5dcd3] px-4 sm:px-8 py-10 md:py-12">
      <div className="mx-auto w-full max-w-6xl">
        {/* Header */}
        <div className="text-left md:text-center">
          <h2 className="text-[#0f0f0f] font-serif text-3xl sm:text-4xl md:text-[42px] tracking-[-0.04em]">
            Explore More SnapTools
          </h2>
          <p className="mt-2 text-sm md:text-base text-[#56504a]">
            Pick a tool and continue your journey with the SnapHomz suite.
          </p>
        </div>

        <div className="mt-8 md:mt-10 grid gap-8 lg:grid-cols-[1.1fr_1.1fr]">
          {/* LEFT: PreApproval */}
          <div className="rounded-[28px] bg-white shadow-[0_20px_60px_rgba(0,0,0,0.1)] border border-[#e6ddd4] overflow-hidden">
            <div className="p-5 md:p-6">
              <div className="flex justify-center">
                <img
                  src={LEFT_FEATURED.logoSrc}
                  alt={LEFT_FEATURED.logoAlt}
                  className="h-11 md:h-12 w-auto block object-contain"
                />
              </div>

              <div className="mt-4 rounded-2xl overflow-hidden border border-[#f0e8e0] bg-[#f7f2ed]">
                <img
                  src={LEFT_FEATURED.gifSrc}
                  alt="PreApproval preview"
                  className="w-full h-auto block"
                  loading="lazy"
                />
              </div>

              <div className="mt-5 grid gap-2 text-sm text-[#4d4640]">
                {LEFT_FEATURED.descPoints.map((p) => (
                  <div key={p} className="flex items-start gap-3">
                    <span className="mt-1 h-2 w-2 rounded-full bg-[#f37721]" />
                    <p>{p}</p>
                  </div>
                ))}
              </div>

              <button
                onClick={() => (window.location.href = LEFT_FEATURED.href)}
                className={`mt-6 mx-auto block ${LEFT_CTA_BUTTON}`}
              >
                Try it now
              </button>
            </div>
          </div>

          {/* RIGHT: Other tools */}
          <div className="rounded-[28px] p-6 md:p-8 bg-gradient-to-b from-[#f7f4ef] via-[#eee8e1] to-[#e3dbd3] border border-[#dcd3c9] shadow-[0_20px_70px_rgba(0,0,0,0.14)]">
            <p className="mb-6 text-base font-medium text-[#5b5550]">
              Pick a tool and continue your journey.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
              {TOOLS.map((t) => (
                <div
                  key={t.key}
                  className="rounded-3xl p-6 min-h-[220px] bg-gradient-to-b from-[#f7f3ee] via-[#e6dfd7] to-[#d4ccc3] border border-[#d9d1c8] shadow-[0_12px_32px_rgba(0,0,0,0.12)] hover:shadow-[0_18px_50px_rgba(0,0,0,0.2)] transition-all flex flex-col"
                >
                  <div className={TOOL_LOGO_WRAP_CLASS}>
                    <img
                      src={t.logoSrc}
                      alt={t.logoAlt}
                      className={`${t.logoClass} block object-contain object-left shrink-0`}
                      loading="lazy"
                    />
                  </div>

                  <p className="mt-2 text-sm text-[#3d3731] leading-relaxed">
                    {t.desc}
                  </p>

                  <div className="mt-auto pt-5">
                    <button
                      onClick={() => (window.location.href = t.href)}
                      className={RIGHT_TILE_BUTTON}
                    >
                      Learn more
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
